import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, use } from 'react';
import { DefaultChatMessage } from './chat/DefaultChatMessage.js';
const RendererContext = createContext({
    ChatRendererComponent: DefaultChatMessage,
    LinkComponent: ({ to, children }) => _jsx("a", { href: to, children: children }),
    navigate: async ({ to }) => {
        history.pushState({}, '', to);
    },
});
export const RendererProvider = RendererContext.Provider;
export function useRendererContext() {
    return use(RendererContext);
}
export function useNavigation() {
    const { LinkComponent, navigate } = useRendererContext();
    return { Link: LinkComponent, navigate };
}
//# sourceMappingURL=RendererProvider.js.map